module.exports = __webpack_public_path__ + "static/img/sw-dashboard.ac03181.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/sw-dashboard.svg
// module id = 0aV1
// module chunks = 4